import { render, staticRenderFns } from "./Cxp.vue?vue&type=template&id=b7594bce&scoped=true"
import script from "./Cxp.vue?vue&type=script&lang=js"
export * from "./Cxp.vue?vue&type=script&lang=js"
import style0 from "./Cxp.vue?vue&type=style&index=0&id=b7594bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7594bce",
  null
  
)

export default component.exports